export const QUIZ_QUESTIONS = [
  {
    id: "business_type",
    question: "What type of business do you run?",
    subtitle: "This helps us tailor recommendations for your industry",
    options: [
      { value: "home_services", label: "Home Services", desc: "Plumbing, HVAC, electrical, etc.", score: 2 },
      { value: "professional", label: "Professional Services", desc: "Law, accounting, consulting", score: 2 },
      { value: "healthcare", label: "Healthcare", desc: "Dental, medical, wellness", score: 2 },
      { value: "retail", label: "Retail / E-commerce", desc: "Shops, online stores", score: 2 },
      { value: "real_estate", label: "Real Estate", desc: "Agents, brokers, property mgmt", score: 2 },
      { value: "restaurant", label: "Restaurant / Food", desc: "Dining, catering, food service", score: 2 },
      { value: "other", label: "Other", desc: "Something else entirely", score: 2 }
    ]
  },
  {
    id: "website_status",
    question: "Do you currently have a website?",
    subtitle: "Your website is the foundation of your online visibility",
    options: [
      { value: "professional", label: "Yes, professional & modern", desc: "Mobile-friendly, fast, looks great", score: 4 },
      { value: "needs_work", label: "Yes, but it needs work", desc: "Outdated design or slow loading", score: 2 },
      { value: "no_website", label: "No website yet", desc: "Haven't gotten around to it", score: 0 },
      { value: "not_sure", label: "Not sure about quality", desc: "I have one but don't know if it's good", score: 1 }
    ]
  },
  {
    id: "customer_source",
    question: "How do customers currently find you?",
    subtitle: "Understanding your current lead sources reveals opportunities",
    options: [
      { value: "google", label: "Google Search", desc: "They search and find my business", score: 4 },
      { value: "word_of_mouth", label: "Word of Mouth", desc: "Referrals from existing customers", score: 2 },
      { value: "social_media", label: "Social Media", desc: "Facebook, Instagram, etc.", score: 2 },
      { value: "paid_ads", label: "Paid Advertising", desc: "Google Ads, Facebook Ads", score: 3 },
      { value: "not_sure", label: "Not sure", desc: "I don't really track this", score: 1 }
    ]
  },
  {
    id: "seo_experience",
    question: "Have you invested in SEO before?",
    subtitle: "Search Engine Optimization is how you rank on Google",
    options: [
      { value: "active", label: "Yes, currently doing SEO", desc: "Working with an agency or doing it myself", score: 4 },
      { value: "tried_stopped", label: "Tried it, but stopped", desc: "Didn't see results or budget ran out", score: 2 },
      { value: "never", label: "Never tried SEO", desc: "Haven't invested in it yet", score: 0 },
      { value: "what_is_seo", label: "What is SEO?", desc: "I'm not familiar with this", score: 0 }
    ]
  },
  {
    id: "ai_search",
    question: "Is your business visible in AI search?",
    subtitle: "100M+ people use ChatGPT weekly for recommendations",
    options: [
      { value: "yes", label: "Yes, we show up", desc: "Verified on ChatGPT, Perplexity, etc.", score: 4 },
      { value: "no", label: "No, we don't appear", desc: "Checked and we're not there", score: 1 },
      { value: "dont_know", label: "I don't know", desc: "Never checked AI search results", score: 0 },
      { value: "what_is_ai", label: "What is AI search?", desc: "First time hearing about this", score: 0 }
    ]
  },
  {
    id: "biggest_challenge",
    question: "What's your biggest online marketing challenge?",
    subtitle: "We'll focus our recommendations on solving this",
    options: [
      { value: "not_enough_traffic", label: "Not enough website traffic", desc: "People can't find me online", score: 1 },
      { value: "low_conversion", label: "Low conversion rates", desc: "Traffic but no leads or sales", score: 2 },
      { value: "dont_know_start", label: "Don't know where to start", desc: "Overwhelmed by all the options", score: 0 },
      { value: "competition", label: "Competition is outranking me", desc: "Rivals dominate search results", score: 1 },
      { value: "need_website", label: "I need a new website", desc: "Current site isn't cutting it", score: 1 }
    ]
  }
];

export const calculateScore = (answers) => {
  const totalScore = answers.reduce((sum, a) => sum + a.score, 0);
  const maxScore = answers.length * 4;
  const percentage = Math.round((totalScore / maxScore) * 100);
  return { totalScore, maxScore, percentage };
};

export const getVisibilityLevel = (percentage) => {
  if (percentage <= 25) return { level: "Invisible", color: "#ef4444", emoji: "invisible" };
  if (percentage <= 50) return { level: "Barely Visible", color: "#f59e0b", emoji: "barely" };
  if (percentage <= 75) return { level: "Partially Visible", color: "#3b82f6", emoji: "partial" };
  return { level: "Highly Visible", color: "#22c55e", emoji: "visible" };
};
